// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__f5_Id","homeBanner":"Banner_homeBanner__YZcPB","infoBanner":"Banner_infoBanner__IiqX7"};